/** InsCoder 2025-02-06 B + Custom PDP Image Text Swiper **/
document.addEventListener('DOMContentLoaded', function() {
  var swiperInstance = null;
  var sectionSelector = '.cust-pdp-image-text-swiper';
  var swiperContainerSelector = sectionSelector + ' .swiper';

  function initSwiper() {
    var isMobile = window.innerWidth < 769;
    var container = document.querySelector(swiperContainerSelector);

    if (isMobile && !swiperInstance && container) {
      swiperInstance = new Swiper(swiperContainerSelector, {
        slidesPerView: 1.1,
        centeredSlides: false,
        spaceBetween: 24,
        loop: false,
        navigation: {
          nextEl: sectionSelector + ' .swiper-button-next',
          prevEl: sectionSelector + ' .swiper-button-prev',
        },
        breakpoints: {
          // Adjust if needed
        }
      });
    } else if (!isMobile && swiperInstance) {
      swiperInstance.destroy(true, true);
      swiperInstance = null;
    }
  }

  // Initialize on load
  initSwiper();

  // Re-check on resize
  window.addEventListener('resize', function() {
    initSwiper();
  });
  
  // Support for Shopify Theme Editor
  if (window.Shopify && window.Shopify.designMode) {
    function isSwiperSection(sectionEl) {
      return sectionEl.matches(sectionSelector) || sectionEl.querySelector(sectionSelector);
    }
    document.addEventListener('shopify:section:load', function(event) {
      if (isSwiperSection(event.target)) initSwiper();
    });
    document.addEventListener('shopify:section:unload', function(event) {
      if (isSwiperSection(event.target) && swiperInstance) {
        swiperInstance.destroy(true, true);
        swiperInstance = null;
      }
    });
  }
});
/** InsCoder 2025-02-06 E + Custom PDP Image Text Swiper **/
